import { getDateTime } from 'services/types';

export const getTableParams = (t) => {
  const getFields = () => {
    const fields = [
      { name: 'created_at', sortField: 'created_at', title: t('grid.Дата и время'), width: 220, render: (val) => getDateTime(val) },
      {
        name: 'vehicle_plate',
        title: t('sections.ГРЗ'),
      },
      {
        name: 'mean_id',
        title: t('grid.СО'),
        width: 140,
      },
    ];

    if (window.config.central) {
      fields.unshift({
        name: 'parking_id',
        title: t('grid.Парковка'),
        render: (val) => <ParkingCell parking_id={val} cmp={'span'} />,
        width: 'auto',
      });
    }

    return fields;
  };

  return { getFields };
};
